import { parse, stringify } from 'lossless-json';

type JSONIdx = Array<Array<number>>;

const scan = (str: string) => {
  if (!str) return [];
  let bracketsCount = 0;
  const jsonIdx: JSONIdx = [];
  let initialJSONIdx: number | null = null;

  for (let i = 0; i < str.length; i += 1) {
    const char = str[i];

    switch (char) {
      case '{':
        if (bracketsCount === 0) {
          initialJSONIdx = i;
        }

        bracketsCount += 1;
        break;
      case '}':
        if (bracketsCount === 1 && initialJSONIdx !== null) {
          jsonIdx.push([initialJSONIdx, i]);
          initialJSONIdx = null;
        }

        bracketsCount -= 1;
        break;
      default:
        break;
    }
  }

  return jsonIdx;
};

const formatJSON = (str: string, jsonIdx: JSONIdx) => {
  if (!str || !jsonIdx.length) return str;
  let formattedStr = '';
  let notJSONIdx = 0;

  for (let i = 0; i < jsonIdx.length; i += 1) {
    const [initialJSONIdx, finalJSONIdx] = jsonIdx[i];
    const rawSlice = str.slice(initialJSONIdx, finalJSONIdx + 1);
    formattedStr += str.slice(notJSONIdx, initialJSONIdx).trim();
    formattedStr += '\n';
    try {
      formattedStr += stringify(parse(rawSlice), null, 2);
    } catch {
      formattedStr += rawSlice;
    }
    formattedStr += '\n';
    notJSONIdx = finalJSONIdx + 1;
  }

  formattedStr += str.slice(notJSONIdx).trim();

  return formattedStr;
};

export function formatMessage(str?: string) {
  if (!str) return str;
  const jsonIdx = scan(str);
  const formattedStr = formatJSON(str, jsonIdx);
  return formattedStr;
}
